import ErrorIcon from '@/assets/icons/error.svg?react'
import InfoIcon from '@/assets/icons/infoIcon.svg?react'
import { INotification, INotificationWsMessage } from '../../notifications.types'
import css from '../Notification/notification.module.css'
import { NotificationIconColors } from './NotificationIconColors.enum'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'

interface IProps {
  notification: INotification | INotificationWsMessage | ISystemEvent
  iconColor?: NotificationIconColors
}

const NotificationIcon = (props: IProps) => {
  switch (true) {
    case props.notification.type === 'ALARM_SITUATION_INCIDENT':
      return <ErrorIcon className={css.icon} color={props.iconColor || NotificationIconColors['WARNING']} />
    case props.notification.type === 'MAINTENANCE_OVERDUE_WARNING':
      return <ErrorIcon className={css.icon} color={NotificationIconColors['WARNING']} />
    case props.notification.type === 'LIFT_ERROR':
    case props.notification.type === 'MAINTENANCE_OVERDUE_FACT':
      return <ErrorIcon className={css.icon} color={NotificationIconColors['DANGER']} />
    case props.notification.type === 'LP_ERROR':
      return <ErrorIcon className={css.icon} color={props.iconColor || NotificationIconColors['DANGER']} />
    default:
      return <InfoIcon className={css.icon} />
  }
}

export default NotificationIcon
